module.exports = __webpack_public_path__ + "static/ambient-8e4d40d4e11ee4b68ce2f610c582ad01.mp3";